import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateFolderDto } from '../../types/vault.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useCreateFolder = () => {
  const { mutate: create, isPending } = useIdempotentAppMutation([QueryKey.CREATE_FOLDER], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreateFolderDto }, { headers }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'vault', 'folders'] },
        { body: data, headers },
      ),
  });
  return { create, isPending };
};
